import { render } from "./IndicatorDaysTo.vue?vue&type=template&id=52af0246&scoped=true"
import script from "./IndicatorDaysTo.vue?vue&type=script&lang=js"
export * from "./IndicatorDaysTo.vue?vue&type=script&lang=js"

import "./IndicatorDaysTo.vue?vue&type=style&index=0&id=52af0246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52af0246"]])

export default __exports__